<template>
	<div>
		<CollectionSelect
			resetSelectionOnClose
			showConfirmationButton
			tooltipText="Move recording"
			title="Move to..."
			@select="checkForLabelsAndMoveSession"
		>
			<button
				:class="{'bg-gray-600': popoverVisible}"
				data-test="move-session-button"
				type="button"
				class="button-icon"
				@click="popoverVisible = !popoverVisible"
			>
				<BaseIcon name="mono/move" />
			</button>

			<template #cta>Move</template>
		</CollectionSelect>
		<ModalMovingSessionWithLabel
			v-if="isMovingSessionWithLabelToAnotherWorkspace"
			@cancel="isMovingSessionWithLabelToAnotherWorkspace = false"
			@confirm="moveSession"
		/>
	</div>
</template>

<script>
import CollectionSelect from 'shared/components/CollectionSelect.vue'
import ModalMovingSessionWithLabel from 'shared/components/ModalMovingSessionWithLabel.vue'

export default {
	name: 'ButtonMoveFromSession',
	components: {
		CollectionSelect,
		ModalMovingSessionWithLabel,
	},
	props: {
		tooltipText: String,
		sessionId: String,
		sessionHasLabels: Boolean,
	},
	emits: ['moved'],
	data() {
		return {
			popoverVisible: false,
			selectedCollection: null,
			isMovingSessionWithLabelToAnotherWorkspace: false,
		}
	},
	methods: {
		checkForLabelsAndMoveSession(collection) {
			this.selectedCollection = collection

			if (this.sessionHasLabels && collection.workspaceId !== this.$store.workspace.id)
				return (this.isMovingSessionWithLabelToAnotherWorkspace = true)

			this.moveSession()
		},
		async moveSession() {
			// is moving session to another workspace
			if (this.selectedCollection.workspaceId !== this.$store.workspace.id) {
				const updateSessionsWorkspaceCollectionLabel = (
					await import('shared/apollo/updateSessionsWorkspaceCollectionLabel')
				).default
				await updateSessionsWorkspaceCollectionLabel({
					sessionIds: [this.sessionId],
					workspaceId: this.selectedCollection.workspaceId,
					oldCollectionId: this.$store.collection.id,
					newCollectionId: this.selectedCollection.id,
				})
			} else {
				const updateSessionsCollection = (await import('shared/apollo/updateSessionsCollection')).default
				await updateSessionsCollection({
					sessionIds: [this.sessionId],
					oldCollectionId: this.$store.collection.id,
					newCollectionId: this.selectedCollection.id,
				})
			}

			const targetWorkspaceName = this.$store.workspaces.find(
				({workspace}) => workspace.id === this.selectedCollection.workspaceId
			).workspace.name
			const notificationMessage = `Moved to <span class="link-blue">${targetWorkspaceName} &gt; ${this.selectedCollection.name}</span>`

			this.$notify.success({
				type: 'success',
				title: 'Session moved',
				message: notificationMessage,
				dangerouslyUseHTMLString: true,
				onClick: () => {
					this.$routerHelpers.replace({
						name: 'workspace-collection',
						params: {
							workspaceId: this.selectedCollection.workspaceId,
							collectionId: this.selectedCollection.id,
						},
					})
				},
			})
			this.isMovingSessionWithLabelToAnotherWorkspace = false
			this.$emit('moved')
		},
	},
}
</script>
